module.exports = "/_next/static/images/num-dian-a1ce061c.png";